export function routes($stateProvider) {
  $stateProvider
    .state('app.investigator', {
      url: '/investigador',
      abstract: true,
      template: '<div ui-view></div>'
    })
    .state('app.investigator.list', {
      url: '?{page:int}&{items:int}&{state:int}&order&sort&filter',
      title: 'Gestão de Investigadores',
      template: require('./directory/directory.view.html'),
      controller: 'InvestigatorListController',
      controllerAs: 'vm',
      role: 'investigadorRead',
      params: {
        state: {
          value: 1,
          dynamic: true
        },
        page: {
          value: 1,
          dynamic: true
        },
        items: {
          value: 20,
          dynamic: true
        },
        order: {
          value: "nome",
          dynamic: true
        },
        sort: {
          value: "asc",
          dynamic: true
        },
        filter: {
          dynamic: true
        }
      }
    })
    .state('app.investigator.details', {
      url: '/{id}',
      title: 'Investigador',
      controller: 'InvestigatorDetailsController',
      controllerAs: 'vm',
      template: require('./details/details.view.html'),
      role: 'investigadorRead'
    })
    .state('app.investigator.new', {
      url: '/novo',
      title: 'Adicionar Investigador',
      template: require('./new/new.view.html'),
      controller: 'InvestigatorCreateInvestigatorController',
      controllerAs: 'vm',
      role: 'investigadorCreate'
    })
    .state('app.investigator.new.1', {
      template: require('./new/investigator.1.form.html')
    })
    .state('app.investigator.new.2', {
      template: require('./new/investigator.2.form.html')
    })
    .state('app.investigator.new.3', {
      template: require('./new/investigator.3.form.html')
    })
  ;
}

routes.$inject = ['$stateProvider'];
